export default "__VITE_ASSET__BNVEByuy__"